<template>
  <!-- 添加拣货单-->
  <div class="AddPicking" v-loading="loading">
    <div class="AddPicking__top">
      <el-descriptions :column="4">
        <el-descriptions-item label="系统单号">
          <div>{{ pickingData.rsys }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="检索单号">
          <el-input v-model="pickingData.sretrieval" placeholder="请输入内容(选填)" />
        </el-descriptions-item>
        <el-descriptions-item label="订单号">
          <div>{{ pickingData.order }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="4">
        <el-descriptions-item label="出货门店">
          <el-select v-model="storeInfo.sid" filterable placeholder="请选择" :filter-method="selectByStoreName" @change="checkStore" disabled>
            <el-option v-for="item in storeOptions" :key="item.sid" :label="item.cname" :value="item.sid" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="门店地址">
          <div class="wHP">{{ storeInfo.caddr }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <div class="flex alignItemsCenter">
        <el-descriptions :column="4">
          <el-descriptions-item label="订单渠道">
            <el-select v-model="pickingData.rchannel" filterable placeholder="请选择">
              <el-option v-for="item in channelOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="顾客地址">
            <el-input v-model="pickingData.customerAddr" placeholder="请输入内容" />
          </el-descriptions-item>
        </el-descriptions>
        <span class="icon iconfont grey">&#xe675;</span>
      </div>
      <el-divider></el-divider>
      <div class="flex alignItemsCenter">
        <el-descriptions :column="4">
          <el-descriptions-item label="销售组织">
            <div class="wHP">{{ pickingData.shopFinanceName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="销售门店">
            <div class="wHP">{{ pickingData.shopName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="库存组织">
            <div class="wHP">{{ pickingData.storeFinanceName }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="出库门店">
            <div class="wHP">{{ storeInfo.cname }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-divider></el-divider>
      <div class="flex">
        <el-descriptions :column="4">
          <el-descriptions-item label="单据状态">
            <el-input v-model="pickingData.remarks" placeholder="请输入内容(选填)" />
          </el-descriptions-item>
          <el-descriptions-item label="单据备注">
            <el-input v-model="pickingData.remarks" placeholder="请输入内容(选填)" />
          </el-descriptions-item>
        </el-descriptions>
        <div class="w200 flex" style="justify-content: flex-end">
          <el-button type="primary" size="mini" plain @click="openDeviceDialog">门店智控</el-button>
        </div>
      </div>
      <div class="flex" v-for="item in meituanGiftList" :key="item.sid">
        <el-descriptions :column="4">
          <el-descriptions-item label="赠品信息">
            {{ item.sremark }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="w200 flex" style="justify-content: flex-end">
          <el-button type="primary" size="mini" plain @click="openDeviceDialog">门店智控</el-button>
        </div>
      </div>
    </div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="订单商品" name="1">
        <div>
          <el-button :disabled="selectOrderTableData.length < 2" type="primary" size="mini" @click="handleMergeChangeOrder">合并</el-button>
        </div>
        <div class="h300 AddPicking__table">
          <el-table ref="multipleTable" :data="orderTableData" row-key="sid" height="300" size="mini" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" :row-style="handleInventoryRed" @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" :selectable="handleOrderSelectable" :reserve-selection="true" width="55"></el-table-column>
            <el-table-column label="序号" align="center" width="50" type="index" />
            <el-table-column prop="cgoodsSku" align="center" label="SKU" width="90" />
            <el-table-column label="图片" align="center" width="70">
              <template #default="scope">
                <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w30 h30" :src="scope.row.cmasterUrl"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="商品编码" align="center" width="130" prop="cgoodsBarcode" />
            <el-table-column label="商品名称" align="center" prop="cgoodsName" />
            <el-table-column label="单位" align="center" width="50" />
            <el-table-column label="单价" align="center" width="100">
              <template slot-scope="scope">
                <div>￥ {{ scope.row.dgoodsPrice / 100 }}</div>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="ngoodsNum" align="center" width="130" />
            <el-table-column label="标注" align="center" width="130" prop="type">
              <template #default="scope">
                <span v-if="scope.row.type === 1" style="color: blue">常规品</span>
                <el-tooltip v-else-if="scope.row.type === 2" class="item" effect="dark" placement="right-end">
                  <div slot="content">
                    <p v-for="item in scope.row.rows" :key="item.sid">
                      {{ item.cname }}
                    </p>
                  </div>
                  <span style="color: #f59a23">虚拟品</span>
                </el-tooltip>
                <span v-else style="color: red">未配置</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="130">
              <template #default="scope">
                <span v-if="scope.row.changeOrderPick" style="color: green">已换</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="55">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="red" @click="handleChangeOrder(scope.row)">换品</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
          <div>
            共计 <span class="blue">{{ orderTableData.length }}种</span> 商品，数量<span class="blue">{{ orderTableData.length }}件</span>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="拣货单货品" name="2">
        <div style="float: right">
          <el-button type="primary" plain @click="dialogVisible = true">加赠品</el-button>
        </div>
        <div class="h450 AddPicking__table">
          <el-table :data="pickTableData" height="400" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
            <el-table-column label="序号" align="center" width="50" type="index" />
            <el-table-column label="图片" align="center" width="70">
              <template #default="scope">
                <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="货品名称" align="left" prop="cname">
              <template #default="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.cname" placement="top-start">
                  <div>{{ scope.row.cname }}</div>
                </el-tooltip>
                <div style="font-size: 12px"><span style="color: #909399">SKU:</span>{{ scope.row.cremark }}</div>
                <div style="font-size: 12px"><span style="color: #909399">条码: </span>{{ scope.row.csku }}</div>
              </template>
            </el-table-column>
            <el-table-column label="货品标签" align="center" width="50" prop="labels" />
            <el-table-column label="单位" align="center" width="50" prop="cunit" />
            <el-table-column label="单价" align="center" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.nprice">￥ {{ scope.row.nrice }}</div>
              </template>
            </el-table-column>
            <el-table-column label="库位" align="center" width="70" prop="c_num">
              <template #default="scope">
                <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces">
                  <el-link type="primary" @click="handleTakeoff(scope.row)">{{ scope.row.cwarehouse }}</el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量" align="center" width="130" prop="num" />
            <el-table-column label="可用库存" align="center" width="60">
              <template slot-scope="scope">
                <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces">
                  <el-link type="primary" @click="handleShowSurplusDialog(scope.row)">{{ scope.row.navailable }}</el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="标注" align="center" width="130">
              <template #default="scope">
                <div v-if="formatRemark(scope.row) === 1" style="color: green">订单品</div>
                <div v-else-if="formatRemark(scope.row) === 2">
                  <div style="color: #f59a23">换货品</div>
                  <i class="el-icon-question" @click="handleOrderPickDetail(scope.row)"></i>
                </div>
                <div v-else style="color: red">赠送品</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="55">
              <template slot-scope="scope">
                <el-button v-if="formatRemark(scope.row) === 2" type="text" size="small" class="blue" @click="handleReOrderChange(scope.row)">重选</el-button><br />
                <el-button v-if="formatRemark(scope.row) !== 1" type="text" size="small" class="red" @click="onDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
          <div>
            共计 <span class="blue">{{ pickTableData.length > 1 ? pickTableData.length - 1 : pickTableData.length }}种</span> 货品
          </div>
          <div>
            <el-button type="primary" @click="doSubmit">提交</el-button>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog v-if="deviceDialogVisible" class="elDialog" :close-on-click-modal="false" title="查看门店智控" :visible.sync="deviceDialogVisible" width="400px" append-to-body>
      <deviceControl :store-info="storeInfo" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="库存校正" :visible.sync="surplusDialog" width="400px" append-to-body>
      <surplusSheet :picking-detail="pickingDetail" @handleSubmit="handleSurplusSheetSubmit" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="添加赠品" :visible.sync="dialogVisible" width="1000px" append-to-body>
      <inventOrderGoodsAdd v-if="dialogVisible" :select-store="{ rstore: storeInfo.sid }" @handleClose="handleClose" @handleChoose="handleChooseGiveGoods" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" :title="changeOrderTitle" :visible.sync="changeOrderVisible" width="1000px" append-to-body>
      <changeOrder v-if="changeOrderVisible" :select-order-table-data="selectOrderTableData" :store-id="storeInfo.sid" @handleSubmit="handleOrderChangeSubmit" @handleClose="handleClose" />
    </el-dialog>
    <el-dialog class="elDialog" :close-on-click-modal="false" title="换品详情" :visible.sync="orderPickVisible" width="1000px" append-to-body>
      <orderPickDetail v-if="orderPickVisible" :order-table-data="orderTableData" :pick-table-data="pickTableData" :order-detail-ids="orderDetailIds" @handleSubmit="handleOrderChangeSubmit" @handleClose="handleClose" />
    </el-dialog>
  </div>
</template>
<script>
import inventOrderGoodsAdd from "./inventOrderGoodsAdd.vue";
import deviceControl from "./deviceControl.vue";
import surplusSheet from "./surplusSheet.vue";
import changeOrder from "./changeOrder.vue";
import orderPickDetail from "./orderPickDetail.vue";

export default {
  name: "EditPicking",
  components: { inventOrderGoodsAdd, deviceControl, surplusSheet, changeOrder, orderPickDetail },
  props: {
    pickingId: {
      type: [String, Object, Array],
      default: "",
    },
  },
  data() {
    return {
      activeNames: ["1", "2"],
      //弹窗
      dialogVisible: false,
      deviceDialogVisible: false,
      surplusDialog: false,
      changeOrderVisible: false,
      orderPickVisible: false,
      changeOrderTitle: "替换商品",
      // 表格列表
      pickTableData: [],
      orderTableData: [],
      selectOrderTableData: [],
      pickingDetail: {},
      orderDetailIds: "",
      // 门店信息
      storeInfo: {},
      storeOptions: [],
      channelOptions: [],
      pickingData: {
        rsys: "",
        retrieval: "",
        order: "",
        customerAddr: "",
        remarks: "",
        rchannel: "",
        shopFinanceName: "",
        storeFinanceName: "",
      },
      loading: false,
      financialList: [],
      privacyList: [],
      meituanGiftList: [],
    };
  },
  created() {
    this.selectAllChannel();
    this.selectById();
    this.selectPrivacy();
  },
  methods: {
    selectGift() {
      this.topsAjax.get(`${this.baseUrls.meituanGift}/list`).then((response) => {
        this.meituanGiftList = response;
      });
    },
    handleOrderSelectable(row) {
      return !row.changeOrderPick;
    },
    formatRemark(row) {
      if (row.rplatformOrderDetail === undefined) {
        return 3;
      }
      
      for (let i = 0; i < this.orderTableData.length; i++) {
        if (row.rplatformOrderDetail.indexOf(this.orderTableData[i].sid) !== -1) {
          if (this.orderTableData[i].cgoodsBarcode === row.csku) {
            return 1;
          }
        }
      }
      if (row.rplatformOrderDetail) {
        return 2;
      }
      return 3;
    },
    handleInventoryRed({ row }) {
      if (this.privacyList.includes(row.cgoodsBarcode)) {
          return { color: "grey" };
      }
      if (row.hasInventory) {
        return {};
      }
      return { color: "red" };
    },
    handleSelectionChange(selection) {
      this.selectOrderTableData = selection;
    },
    handleChangeOrder(row) {
      if (this.storeInfo.sid === undefined) {
        this.$message.error("请先选择门店");
        return;
      }
      this.changeOrderTitle = "替换商品";
      this.changeOrderVisible = true;
      this.selectOrderTableData = [row];
    },
    handleMergeChangeOrder() {
      if (this.storeInfo.sid === undefined) {
        this.$message.error("请先选择门店");
        return;
      }
      this.changeOrderTitle = "合并换品";
      this.changeOrderVisible = true;
    },
    handleShowSurplusDialog(row) {
      console.log(row)
      this.pickingDetail = { ...row };
      this.surplusDialog = true;
    },
    handleOrderPickDetail(row) {
      this.orderDetailIds = row.rplatformOrderDetail;
      this.orderPickVisible = true;
    },
    handleSurplusSheetSubmit(surplus) {
      if (surplus > this.pickingDetail.n_total) {
        for (let i = 0; i < this.pickTableData.length; i++) {
          if (this.pickTableData[i].pdSid === this.pickingDetail.pdSid) {
            this.pickTableData[i].n_total = surplus;
            let check = surplus - this.pickingDetail.n_total;
            this.pickTableData[i].n_surplus = this.pickTableData[i].n_surplus + check;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.pickTableData.length; i++) {
          if (this.pickTableData[i].pdSid === this.pickingDetail.pdSid) {
            this.pickTableData[i].n_total = surplus;
            let check = this.pickingDetail.n_total - surplus;
            this.pickTableData[i].n_surplus = this.pickTableData[i].n_surplus - check;
            break;
          }
        }
      }
    },
    handleOrderChangeSubmit(replaceTableData, orderArr) {
      this.handleOrderChangeOrderTableChange(orderArr);
      this.handleOrderChangePickTableChange(replaceTableData, orderArr);
      this.$refs.multipleTable.clearSelection();
      this.handleClose();
    },
    handleOrderChangeOrderTableChange(orderArr) {
      let arr = [];
      for (let i = 0; i < this.orderTableData.length; i++) {
        arr.push(this.orderTableData[i]);
        if (orderArr.includes(this.orderTableData[i].sid)) {
          this.orderTableData[i].changeOrderPick = true;
          this.orderTableData[i].hasInventory = true;
        }
      }
    },
    handleOrderChangePickTableChange(replaceTableData, orderArr) {
      let arr = [];
      for (let i = 0; i < this.pickTableData.length; i++) {
        let notExist = true;
        for (let j = 0; j < orderArr.length; j++) {
          if (this.pickTableData[i].rplatformOrderDetail === undefined) {
            continue;
          }
          if (this.pickTableData[i].rplatformOrderDetail.indexOf(orderArr[j]) !== -1) {
            notExist = false;
            break;
          }
        }
        if (notExist) {
          arr.push(this.pickTableData[i]);
        }
      }
      for (let i = 0; i < replaceTableData.length; i++) {
        arr.push(replaceTableData[i]);
      }
      this.pickTableData = arr;
    },
    handleReOrderChange(row) {
      let ids = row.rplatformOrderDetail.split(",");
      let arr = [];
      for (let i = 0; i < this.orderTableData.length; i++) {
        if (ids.includes(this.orderTableData[i].sid)) {
          arr.push(this.orderTableData[i]);
        }
      }
      this.selectOrderTableData = arr;
      this.changeOrderVisible = true;
      this.changeOrderTitle = "重选换品";
    },
    handleChooseGiveGoods(goodsList) {
      let arr = [];
      for (let i = 0; i < this.pickTableData.length; i++) {
        let needAdd = true;
        for (let j = 0; j < goodsList.length; j++) {
          if (goodsList[j].cbarcode === this.pickTableData[i].csku) {
            needAdd = false;
            break;
          }
        }
        if (needAdd) {
          arr.push(this.pickTableData[i]);
        }
      }
      this.pickTableData = arr;
      for (let i = 0; i < goodsList.length; i++) {
        goodsList[i].rplatformOrderDetail = "";
        this.pickTableData.push(goodsList[i]);
      }
      this.handleClose();
    },
    handleClose() {
      this.surplusDialog = false;
      this.changeOrderVisible = false;
      this.dialogVisible = false;
      this.orderPickVisible = false;
    },
    handleTakeoff(row) {
      if (this.pickingId === "") {
        return;
      }
      this.$confirm("对货品强制下架操作将不能再拣货，确认要强制下架？").then((_) => {
        let url = `${this.baseUrls.orderInventory}/offWarehouseById`;
        this.topsAjax.post(url, { sid: row.sid }).then(() => {
          row.nout = 0;
          this.$message({
            message: "下架成功",
            type: "success",
          });
        });
      });
    },
    openDeviceDialog() {
      if (this.storeInfo.sid) {
        this.deviceDialogVisible = true;
      } else {
        this.$message.error("请选择门店！");
      }
    },
    AddGoods(goodsList) {
      this.dialogVisible = false;
      if (goodsList.length > 0) {
        this.pickTableData = goodsList;
        this.pickTableData.push({});
      }
    },
    selectAllChannel() {
      let url = `${this.baseUrls.ordPicking}/selectAllChannel`;
      this.topsAjax.get(url).then((response) => {
        this.channelOptions = response;
      });
    },
    selectPrivacy() {
      this.topsAjax.get(`${this.baseUrls.privacy}/queryBarcodeList`).then((response) => {
        this.privacyList = response;
      });
    },
    selectById() {
      let url = `${this.baseUrls.ordPicking}/selectByIdForUpdate`;
      let params = { sid: this.pickingId };
      this.topsAjax.get(url, params).then((res) => {
        let pickingInfo = res.picking;
        if (pickingInfo.rchannel === "CU009") {
          this.selectGift();
        }
        this.pickingData.rsys = pickingInfo.rsys;
        this.pickingData.sretrieval = pickingInfo.sretrieval;
        this.pickingData.order = pickingInfo.rorder;
        this.pickingData.customerAddr = pickingInfo.ccustomerAddr;
        this.pickingData.remarks = pickingInfo.cremark;
        this.pickingData.rchannel = pickingInfo.rchannel;
        this.pickingData.shopName = pickingInfo.shopName;
        this.pickingData.shopFinance = pickingInfo.shopFinance;
        this.pickingData.storeFinance = pickingInfo.storeFinance;
        if (pickingInfo.rstore !== undefined && pickingInfo.rstore !== "") {
          this.storeInfo.sid = pickingInfo.rstore;
          this.storeInfo.cname = pickingInfo.sstore;
          this.storeInfo.caddr = pickingInfo.sstoreAddr;
          this.storeOptions = [this.storeInfo];
        }
        for (let i = 0; i < res.orderDetailList.length; i++) {
          let match = false;
          let hasInventory = false;
          for (let j = 0; j < res.pickingDetailList.length; j++) {
            if (res.pickingDetailList[j].rplatformOrderDetail === undefined) {
              continue;
            }
            
            let ids = res.pickingDetailList[j].rplatformOrderDetail.split(",");
            if (ids.includes(res.orderDetailList[i].sid)) {
              if (res.pickingDetailList[j].sid !== undefined) {
                hasInventory = true;
              }
              if (res.pickingDetailList[j].sid !== undefined && res.orderDetailList[i].cgoodsBarcode !== res.pickingDetailList[j].csku) {
                match = true;
              }
              break;
            }
          }
          if (match) {
            res.orderDetailList[i].changeOrderPick = true;
          } else {
            res.orderDetailList[i].changeOrderPick = false;
          }
          if (hasInventory) {
            res.orderDetailList[i].hasInventory = true;
          } else {
            res.orderDetailList[i].hasInventory = false;
          }
        }
        let pickArr = [];
        for (let i = 0; i < res.pickingDetailList.length; i++) {
          if (res.pickingDetailList[i].sid !== undefined) {
            pickArr.push(res.pickingDetailList[i]);
          }
        }
        this.pickTableData = pickArr;
        this.orderTableData = res.orderDetailList;
        this.topsAjax.get(`${this.baseUrls.orderShop}/financial`).then((response) => {
          this.financialList = response;
          for (let i = 0; i < response.length; i++) {
            if (this.pickingData.shopFinance === response[i].id) {
              this.pickingData.shopFinanceName = response[i].name;
            }
            if (this.pickingData.storeFinance === response[i].id) {
              this.pickingData.storeFinanceName = response[i].name;
            }
          }
        });
        for (let i = 0; i < this.orderTableData.length; i++) {
          this.topsAjax.get(`${this.baseUrls.productPool}/goodsType`, { barcode: this.orderTableData[i].cgoodsBarcode }).then((response) => {
            this.$set(this.orderTableData, i, { ...this.orderTableData[i], type: response.type, rows: response.rows });
          });
        }
      });
    },
    selectByStoreName(value) {
      if (value.length > 0) {
        let url = `${this.baseUrls.orderStore}/queryList`;
        let stoStore = {
          cName: value,
          bStatus: 2,
        };
        this.topsAjax.get(url, stoStore).then((res) => {
          this.storeOptions = res;
        });
      } else {
        this.storeOptions = [];
      }
    },
    checkStore(value) {
      if (this.storeInfo.cname) {
        this.pickTableData = [];
        for (let i = 0; i < this.orderTableData.length; i++) {
          this.orderTableData[i].changeOrderPick = false;
          this.orderTableData[i].hasInventory = false;
        }
      }
      for (let i = 0; i < this.storeOptions.length; i++) {
        if (this.storeOptions[i].sid === value) {
          this.storeInfo = { ...this.storeOptions[i] };
          break;
        }
      }
      for (let i = 0; i < this.financialList.length; i++) {
        if (this.financialList[i].id === this.storeInfo.cfinance) {
          this.pickingData.storeFinanceName = this.financialList[i].name;
          break;
        }
      }
      this.storeOptions = [];
    },
    onDel(index) {
      let item = this.pickTableData.splice(index, 1);
      let rplatformOrderDetails = item[0].rplatformOrderDetail.split(",");
      for (let i = 0; i < this.orderTableData.length; i++) {
        if (rplatformOrderDetails.includes(this.orderTableData[i].sid)) {
          this.orderTableData[i].hasInventory = false;
          this.orderTableData[i].changeOrderPick = false;
        }
      }
    },
    doSubmit() {
      if (!this.storeInfo.sid) {
        this.$message.error("请选择门店!");
        return;
      }
      if (!this.pickingData.rchannel) {
        this.$message.error("请选择订单渠道!");
        return;
      }

      // for (let i = 0; i < this.orderTableData.length; i++) {
      //   if (this.orderTableData[i].hasInventory === false && !this.privacyList.includes(this.orderTableData[i].cgoodsBarcode)) {
      //     this.$message.error("您还有未换品的商品!");
      //     return;
      //   }
      // }
      for (let i = 0; i < this.pickTableData.length; i++) {
        if (this.pickTableData[i].sid === undefined) {
          this.$message.error("请选择商品!");
          return;
        }
        if (this.pickTableData[i].num > this.pickTableData[i].navailable) {
          this.$message.error("库存不足，请检查商品数量是否大于可用库存!");
          return;
        }
      }
      let parameter = {
        picking: {
          sid: this.pickingId,
          sretrieval: this.pickingData.retrieval,
          rorder: this.pickingData.order,
          rstore: this.storeInfo.sid,
          sstore: this.storeInfo.cname,
          sstoreAddr: this.storeInfo.caddr,
          ccustomerAddr: this.pickingData.customerAddr,
          cremark: this.pickingData.remarks,
          rchannel: this.pickingData.rchannel,
        },
        goodsList: this.pickTableData,
      };

      let url = `${this.baseUrls.ordPicking}/order/updatePickingDetail`;
      this.loading = true;
      this.topsAjax
        .post(url, parameter)
        .then(() => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.cancel();
        })
        .catch(res => {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    /**
     * 取消
     */
    cancel() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="scss" scoped>
.AddPicking {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__top {
    .el-divider--horizontal {
      margin: 7px 0;
    }

    .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
      padding-bottom: 5px;
    }

    .el-input--medium .el-input__inner {
      height: 20px;
      line-height: 20px;
    }

    .el-input__inner {
      border: 0px;
    }

    //隐藏图标
    .el-input__icon {
      display: none;
    }
  }

  &__table {
    .el-input-number--medium {
      width: 100px;
    }

    .el-tabs__item.is-active {
      text-decoration: underline;
    }

    .el-popper[x-placement^="bottom"] {
      margin-left: -40px;
    }
  }
}
</style>
